import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import api from "../utils/api";
import adminXB from "../assets/adminXB.png"; // Xbox logo
import adminPS from "../assets/adminPS.png"; // PlayStation logo
import adminPC from "../assets/adminPC.png"; // PC logo
import { useAuth } from "../context/AuthContext";

const BuyingPrice = () => {
  const { token } = useAuth();
  const [prices, setPrices] = useState(null);
  const [editablePrices, setEditablePrices] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPrices = async () => {
      setLoading(true);
      try {
        const response = await api.get("/prices", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setPrices(response.data);
        if (response.data && response.data.length > 0) {
          setEditablePrices(response.data[0]);
        }
      } catch (err) {
        setError("Failed to fetch prices. Please try again later.");
        console.error("Error fetching prices:", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPrices();
  }, [token]);

  const handleEdit = () => setIsEditing(true);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditablePrices((prevPrices) => ({
      ...prevPrices,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    try {
      await api.put(`/prices/${editablePrices._id}`, editablePrices, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setIsEditing(false);
    } catch (err) {
      console.error("Error updating price:", err);
    }
  };

  if (loading) return <p className="text-gray-600">Loading prices...</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  return (
   <>
    <div className="flex flex-col sm:flex-row">
      {/* Sidebar */}
      <div className="block">
        <Sidebar />
      </div>

      {/* Content */}
      <div className="flex-1 bg-gray-50 p-4 sm:p-6 lg:p-8">
        <h1 className="text-xl sm:text-2xl font-bold text-gray-700 text-center sm:text-left">
          Pricing/100K
        </h1>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 mt-6">
          {/* Xbox */}
          <div>
            <div className="flex items-center mb-2">
              <img src={adminXB} alt="Xbox" className="w-6 h-6 mr-2" />
              <label className="font-medium text-gray-700">Xbox Coin Rate</label>
            </div>
            <input
              type="number"
              name="XB"
              value={editablePrices?.XB || ""}
              onChange={handleChange}
              disabled={!isEditing}
              className={`w-full border rounded-lg p-2 ${isEditing
                ? "focus:outline-none focus:ring focus:border-primary"
                : "bg-gray-200"
                }`}
            />
          </div>

          {/* PS */}
          <div>
            <div className="flex items-center mb-2">
              <img src={adminPS} alt="PlayStation" className="w-6 h-6 mr-2" />
              <label className="font-medium text-gray-700">PS Coin Rate</label>
            </div>
            <input
              type="number"
              name="PS"
              value={editablePrices?.PS || ""}
              onChange={handleChange}
              disabled={!isEditing}
              className={`w-full border rounded-lg p-2 ${isEditing
                ? "focus:outline-none focus:ring focus:border-primary"
                : "bg-gray-200"
                }`}
            />
          </div>

          {/* PC */}
          <div>
            <div className="flex items-center mb-2">
              <img src={adminPC} alt="PC" className="w-6 h-6 mr-2" />
              <label className="font-medium text-gray-700">PC Coin Rate</label>
            </div>
            <input
              type="number"
              name="PC"
              value={editablePrices?.PC || ""}
              onChange={handleChange}
              disabled={!isEditing}
              className={`w-full border rounded-lg p-2 ${isEditing
                ? "focus:outline-none focus:ring focus:border-primary"
                : "bg-gray-200"
                }`}
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row justify-center sm:justify-start items-center mt-6 space-y-4 sm:space-y-0 sm:space-x-4">
          {isEditing ? (
            <button
              onClick={handleSave}
              className="w-full sm:w-auto px-6 py-2 bg-green-500 text-white font-medium rounded-lg hover:bg-green-600"
            >
              Save
            </button>
          ) : (
            <button
              onClick={handleEdit}
              className="w-full sm:w-auto px-6 py-2 bg-black text-white font-medium rounded-lg hover:bg-gray-800"
            >
              Edit
            </button>
          )}
        </div>
      </div>
    </div>
   </>
  );
};

export default BuyingPrice;
